import { ColDef } from "ag-grid-community";
import { ec2ColumnDefs } from "./aws/ec2ColumnDefs";
import { ebsColumnDefs } from "./aws/ebsColumnDefs";
import { s3ColumnDefs } from "./aws/s3ColumnDefs";
import { ebsSnapshotColumnDefs } from "./aws/ebsSnapshotColumnDefs";
import { eipColumnDefs } from "./aws/eipColumnDefs";
import { elbColumnDefs } from "./aws/elb-column-defs/elbColumnDefs";
import { rdsColumnDefs } from "./aws/rdsColumnDefs";
import { dynamoDbTableColumnDefs } from "./aws/dynamo-db-table-column-defs/dynamoDbTableColumnDefs";
import { daxClusterColumnDefs } from "./aws/daxClusterColumnDefs";
import { natGatewayColumnDefs } from "./aws/nat-gateway-column-defs/natGatewayColumnDefs";
import { vmColumnDefs } from "./gcp/vmColumnDefs";
import { diskColumnDefs } from "./gcp/diskColumnDefs";
import { ipColumnDefs } from "./gcp/ipColumnDefs";
import { lbColumnDefs } from "./gcp/lbColumnDefs";
import { sqlColumnDefs } from "./gcp/sqlColumnDefs";
import { azVmColumnDefs } from "./azure/azVmColumnDefs";
import { azDiskColumnDefs } from "./azure/azDiskColumnDefs";
import { azIpColumnDefs } from "./azure/azIpColumnDefs";
import { azLbColumnDefs } from "./azure/azLbColumnDefs";
import { azSqlColumnDefs } from "./azure/azSqlColumnDefs";
import { eksColumnDefs } from "./aws/eksColumnDefs";
import { nodeGroupColumnDefs } from "./aws/nodeGroupColumnDefs";
import { eksEc2ColumnDefs } from "./aws/eksEc2ColumnDefs";
import { asgEc2ColumnDefs } from "./aws/asgEc2ColumnDefs";
import { asgColumnDefs } from "./aws/asgColumnDefs";
import { rdsSnapshotColumnDefs } from "./aws/rdsSnapshotColumnDefs";
import { rdsSnapshotSourceColumnDefs } from "./aws/rds-snapshot-source-column-def/rdsSnapshotSourceColumnDefs";
import { elcColumnDefs } from "./aws/elcColumnDefs";
import { dynamoDbBackupColumnDefs } from "./aws/dynamoDbBackupColumnDefs";
import { dynamoDbBackupSourceColumnDefs } from "./aws/dynamoDbBackupSourceColumnDefs";
import { ecsColumnDefs } from "./aws/ecsColumnDefs";
import { ecsWorkloadColumnDefs } from "./aws/ecsWorkloadColumnDefs";
import { nodePoolColumnDefs } from "./gcp/nodePoolColumnDefs";
import { migColumnDefs } from "./gcp/migColumnDefs";
import { migVmColumnDefs } from "./gcp/migVmColumnDefs";
import { gkeColumnDefs } from "./gcp/gkeColumnDefs";
import { gkeVmColumnDefs } from "./gcp/gkeVmColumnDefs";
import { azVmssColumnDefs } from "./azure/azVmssColumnDefs";
import { azVmssVmColumnDefs } from "./azure/az-vmss-vm-column-def/azVmssVmColumnDefs";
import { azAksColumnDefs } from "./azure/azAksColumnDefs";
import { azNodePoolColumnDefs } from "./azure/azNodePoolColumnDefs";
import { azAksVmColumnDefs } from "./azure/azAksVmColumnDefs";
import { k8sNodeColumnDefs } from "./kubernetes/k8sNodeColumnDefs";
import { k8sNamespaceColumnDefs } from "./kubernetes/k8sNamespaceColumnDefs";
import { k8sPodColumnDefs } from "./kubernetes/k8sPodColumnDefs";
import { k8sDeploymentColumnDefs } from "./kubernetes/k8sDeploymentColumnDefs";
import { k8sDaemonSetColumnDefs } from "./kubernetes/k8sDaemonSetColumnDefs";
import { k8sStatefulSetColumnDefs } from "./kubernetes/k8sStatefulSetColumnDefs";
import { k8sReplicaSetColumnDefs } from "./kubernetes/k8sReplicaSetColumnDefs";
import { k8sJobColumnDefs } from "./kubernetes/k8sJobColumnDefs";
import { ResourceType } from "@/services/cloudchipr.api";
import { lambdaColumnDefs } from "@/components/pages/common/resources-ag-grid/components/column-defs/aws/lambdaColumnDefs";

export const columnDefsMap = new Map<ResourceType, ColDef[]>([
  // AWS
  ["eks", eksColumnDefs],
  ["node_group", nodeGroupColumnDefs],
  ["eks_ec2", eksEc2ColumnDefs],
  ["asg_ec2", asgEc2ColumnDefs],
  ["asg", asgColumnDefs],
  ["ec2", ec2ColumnDefs],
  ["s3", s3ColumnDefs],
  ["ebs", ebsColumnDefs],
  ["ebs_snapshot", ebsSnapshotColumnDefs],
  ["elb", elbColumnDefs],
  ["eip", eipColumnDefs],
  ["rds", rdsColumnDefs],
  ["rds_snapshot", rdsSnapshotColumnDefs],
  ["rds_snapshot_source", rdsSnapshotSourceColumnDefs],
  ["elc", elcColumnDefs],
  ["dynamo_db_table", dynamoDbTableColumnDefs],
  ["dynamo_db_backup", dynamoDbBackupColumnDefs],
  ["dynamo_db_backup_source", dynamoDbBackupSourceColumnDefs],
  ["dax_cluster", daxClusterColumnDefs],
  ["nat_gateway", natGatewayColumnDefs],
  ["ecs", ecsColumnDefs],
  ["ecs_workload", ecsWorkloadColumnDefs],
  ["lambda", lambdaColumnDefs],

  // GCP
  ["node_pool", nodePoolColumnDefs],
  ["vm", vmColumnDefs],
  ["mig", migColumnDefs],
  ["mig_vm", migVmColumnDefs],
  ["disk", diskColumnDefs],
  ["sql", sqlColumnDefs],
  ["ip", ipColumnDefs],
  ["lb", lbColumnDefs],
  ["gke", gkeColumnDefs],
  ["gke_vm", gkeVmColumnDefs],

  // Azure
  ["az_vm", azVmColumnDefs],
  ["az_vmss", azVmssColumnDefs],
  ["az_vmss_vm", azVmssVmColumnDefs],
  ["az_disk", azDiskColumnDefs],
  ["az_ip", azIpColumnDefs],
  ["az_lb", azLbColumnDefs],
  ["az_sql", azSqlColumnDefs],
  ["az_aks", azAksColumnDefs],
  ["az_node_pool", azNodePoolColumnDefs],
  ["az_aks_vm", azAksVmColumnDefs],

  // Kubernetes
  ["kubernetes_node", k8sNodeColumnDefs],
  ["kubernetes_namespace", k8sNamespaceColumnDefs],
  ["kubernetes_pod", k8sPodColumnDefs],
  ["kubernetes_deployment", k8sDeploymentColumnDefs],
  ["kubernetes_daemon_set", k8sDaemonSetColumnDefs],
  ["kubernetes_stateful_set", k8sStatefulSetColumnDefs],
  ["kubernetes_replica_set", k8sReplicaSetColumnDefs],
  ["kubernetes_job", k8sJobColumnDefs],
]);
